import { AbstractAggregateChartsComponent } from "../../abstract-aggregate-charts.component";
import Highcharts, { AxisOptions } from 'highcharts';
import { ElementRef } from "@angular/core";
import { LoadingError } from "../../../../core/error-catching.service";
import { DateRange, PresetDateRanges } from "../../../../shared/date/date-range";
import { Observable } from "rxjs";
import { AverageData } from "../../../../api/model/averageData";
import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { BLUE, GREEN, ORANGE } from "../../../colors";
import { TransformedAggregate } from "../../abstract-aggregate-summary.component";
import { AggregateData } from "../../../../api/model/aggregateData";
import { takeUntil, catchError } from 'rxjs/operators';


export function formatToolTipPoint(point, pipe: CurrencyPipe)
{

}

export function formatToolTip(point, pipe: CurrencyPipe){
    if(point.y === 0){
        return false;
    }

    let value = pipe.transform(point.y, "USD", true, ".2");


    return `
            ${point.key} <br>
            ${value}
    `;
}

export abstract class AbstractCorporateDashboardChartsComponent extends AbstractAggregateChartsComponent {

    protected currencyPipe: CurrencyPipe = new CurrencyPipe("en");

    customizeChartOptions(options: Highcharts.Options) {
        options.legend.enabled = false;
        options.plotOptions.column = {
            groupPadding: -0.1,
            stacking: 'normal'
        };


        let yAxis = options.yAxis;
        if(yAxis[0]){
            let primaryAxis = yAxis[0];
            primaryAxis.visible = false;
        }else{
            let singleAxis = yAxis as AxisOptions;
            singleAxis.visible = false;
        }

        let xAxis = options.xAxis;
        if(xAxis[0]){
            let primaryAxis = xAxis[0];
            primaryAxis.labels={};
            primaryAxis.labels.style = {fontSize: '10px'}
        }else{
            let singleAxis = xAxis as AxisOptions;
            singleAxis.labels={};
            singleAxis.labels.style = {fontSize: '10px',}
        }

        let pipe = this.currencyPipe;

        options.tooltip.formatter = function() { return formatToolTip(this, pipe); };

    }

    getDataForChart(overall: Observable<number>, aggregate: Observable<AverageData[]>, chart: Highcharts.Chart, chartDivRef: ElementRef){

        overall
           .pipe(takeUntil(this.stop$),
                catchError((error)=>{
                    throw new LoadingError(chart.options.title.text);
                }))
            .subscribe((data: number) => {

                let formattedData: string;

                if(typeof data === 'number'){
                    formattedData = this.currencyPipe.transform(data, "USD", "symbol", ".2");
                    chart = super.resetChart(chart, chartDivRef);
                }

                aggregate
                    .pipe(takeUntil(this.stop$),
                        catchError((error) => {
                            throw new LoadingError(chart.options.title.text);
                        }))
                    .subscribe((data2: AverageData[]) => {
                        if(data2.length===1){
                            chart.options.colors = [GREEN];
                        }else{
                            chart.options.colors = [BLUE, ORANGE, GREEN];
                        }

                        this.populateColumns(chart, this.transformAggregateData(data2));

                        if(data2.length) {
                            this.setCustomSubTitle(formattedData, chart);
                        }
                    });

            });
    }

    private setCustomSubTitle(subTitleText: string, chart: Highcharts.Chart){
        let subtitle: Highcharts.SubtitleOptions
            = {text: subTitleText};

        subtitle.align = 'center';
        // reset current subtitle to ensure we have the right defaults
        chart.options.subtitle = null;

        chart.setTitle(null, subtitle);
    }

    protected calculateBillingDateRange(rangeName: string): DateRange {
        let billCutOffDate = this.facilitiesSvc.billCutOffDateForSelectedFacility;

        let initalRange =  PresetDateRanges.find(x => x.display === rangeName).getRange();

        try {
            var startDateWithBillCutOff = initalRange.startDate.withDayOfMonth(billCutOffDate);
            var endDateWithBillCutOff = initalRange.endDate.withDayOfMonth(billCutOffDate);

            let startDateThisMonth = startDateWithBillCutOff.plusMonths(-1).plusDays(1);
            let endDateThisMonth  = endDateWithBillCutOff;
            return new DateRange(startDateThisMonth,endDateThisMonth);
        } catch (error) {
            //if the billCutOffDate is invalid for that month, it will default to
            //whatever the UI has.
            return new DateRange(initalRange.startDate, initalRange.endDate);
        }

    }
}